import { ApiService } from "@/api";

export const getAllFeedbackList = () => {
  return ApiService.baseAction("feedback/all/list", {}, "get");
};
